import { NavLink } from "react-router-dom";
import { config, navItems, eventDateDisplay } from "@/config/eventConfig";
import { RightNowBar } from "@/components/RightNowBar";
import { useOnline } from "@/hooks/useOnline";

export const Layout = ({ children, onNotYou }) => {
  const online = useOnline();
  return (
    <div className="min-h-screen flex flex-col bg-cream text-ink font-body">
      {/* Header */}
      <header data-testid="app-header" className="border-b border-sand">
        <div className="max-w-5xl mx-auto w-full px-6 py-5 flex items-center justify-between gap-4">
          <span
            data-testid="app-wordmark"
            className="font-display text-2xl sm:text-3xl tracking-wide leading-none whitespace-nowrap"
          >
            {config.event_name}
          </span>
          {config.event_subtitle && (
            <span className="mono-label text-ink/60 text-right">
              {config.event_subtitle}
            </span>
          )}
        </div>
      </header>

      {/* Navigation: items and order come from config */}
      <nav data-testid="app-nav" className="border-b border-sand bg-cream">
        <div className="max-w-5xl mx-auto w-full px-6">
          <ul className="flex flex-wrap gap-x-8 gap-y-1">
            {navItems.map((item) => (
              <li key={item.slug}>
                <NavLink
                  to={`/${item.slug}`}
                  data-testid={`nav-${item.slug}`}
                  className={({ isActive }) =>
                    [
                      "inline-block py-4 text-sm border-b-2 -mb-px transition-colors duration-150",
                      isActive
                        ? "border-orange text-orange-dark"
                        : "border-transparent text-ink/70 hover:text-orange-dark",
                    ].join(" ")
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Quiet offline notice, screens still render from local state */}
      {!online && (
        <div data-testid="offline-label" className="bg-sand/60 border-b border-sand">
          <div className="max-w-5xl mx-auto w-full px-6 py-2">
            <span className="mono-label text-ink/60">
              Offline, showing last known state
            </span>
          </div>
        </div>
      )}

      {/* Right Now bar: persistent, directly under the header shell */}
      <RightNowBar />

      {/* Main */}
      <main className="flex-1">
        <div className="max-w-5xl mx-auto w-full px-6 py-10">{children}</div>
      </main>

      {/* Footer: event name and date only */}
      <footer data-testid="app-footer" className="border-t border-sand mt-auto">
        <div className="max-w-5xl mx-auto w-full px-6 py-5 flex items-center justify-between text-sm text-ink/60">
          <span>
            {config.event_name} · {eventDateDisplay}
          </span>
          {onNotYou && (
            <button
              type="button"
              data-testid="not-you-link"
              onClick={onNotYou}
              className="underline underline-offset-4 hover:text-orange-dark transition-colors duration-150"
            >
              {config.ui.footer.not_you}
            </button>
          )}
        </div>
      </footer>
    </div>
  );
};
